import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../core/http.service';
import { environment } from '@base/environments/environment';
import { Observable, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoggedUserService extends HttpService {
  private inFlightGet: Promise<any> | null = null;

  constructor(public override http: HttpClient) {
    super(http);
    this.url = '/logged-user';
    this.baseUrl = environment.oldFrontUrl;
  }

  override async get(): Promise<any> {
    if (!this.inFlightGet) {
      this.inFlightGet = firstValueFrom(this.getObservable()).finally(() => {
        this.inFlightGet = null;
      });
    }

    return this.inFlightGet;
  }

  override getObservable(): Observable<any> {
    return this.http.get<any>(this.baseUrl + this.url);
  }
}
